import React, { useEffect, useState } from "react";
import { ArrowUpRight, Newspaper } from "lucide-react";
import { api } from "@/lib/api";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

export default function LatestNews() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/news")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section
      id="news"
      className="py-16 lg:py-24 border-t border-[var(--border)]"
      data-testid="latest-news-section"
    >
      <div className="container-nk">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-9">
          <div>
            <p className="eyebrow flex items-center gap-2 text-gold">
              <Newspaper size={13} />
              // News &amp; Updates
            </p>
            <h2 className="font-display text-[44px] md:text-[60px] leading-[0.95] mt-3">
              Latest News
            </h2>
            <p className="text-muted text-[14px] mt-3 max-w-md font-light leading-relaxed">
              What's happening at Naami — brand launches, special offers,
              opening hours, press coverage and more.
            </p>
          </div>
          <span className="inline-flex items-center gap-2 font-mono text-[10.5px] uppercase tracking-[0.18em] text-muted">
            {items.length} update{items.length === 1 ? "" : "s"}
          </span>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((n, i) => {
            const hasLink = !!(n.link && n.link.trim());
            const Wrapper = hasLink ? "a" : "div";
            const wrapperProps = hasLink
              ? { href: n.link, target: "_blank", rel: "noopener noreferrer" }
              : {};
            return (
              <Wrapper
                key={n.id}
                {...wrapperProps}
                className="news-card group"
                data-testid={`latest-news-card-${i}`}
              >
                {n.image && (
                  <div className="news-card-img">
                    <img src={n.image} alt={n.headline} loading="lazy" />
                  </div>
                )}
                <div className="news-card-body">
                  <div className="flex items-center gap-2 flex-wrap">
                    {n.category && (
                      <span className="news-card-cat">{n.category}</span>
                    )}
                    <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-muted">
                      {formatDate(n.published_at)}
                    </span>
                  </div>
                  <h3 className="font-display text-[22px] md:text-[24px] leading-tight mt-3">
                    {n.headline}
                  </h3>
                  {n.blurb && (
                    <p className="text-[13.5px] text-[var(--text)]/70 mt-2 leading-relaxed">
                      {n.blurb}
                    </p>
                  )}
                  {hasLink && (
                    <span className="news-card-cta">
                      Read more
                      <ArrowUpRight size={13} />
                    </span>
                  )}
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
